import Card from '../components/Card';

const NotFound = () => (
  <main className="mx-auto flex min-h-screen max-w-xl items-center justify-center p-4">
    <Card className="w-full text-center">
      <h1 className="text-xl font-semibold text-slate-900">Page not found</h1>
      <p className="mt-2 text-sm text-slate-600">
        We couldn&apos;t find the page you&apos;re looking for. Please check the link and try again.
      </p>
    </Card>
  </main>
);

export default NotFound;
